import script from "./addEnrollPage.vue?vue&type=script&setup=true&lang=js"
export * from "./addEnrollPage.vue?vue&type=script&setup=true&lang=js"

import "./addEnrollPage.vue?vue&type=style&index=0&id=4873cdb6&lang=scss&scoped=true"
import "./addEnrollPage.vue?vue&type=style&index=1&id=4873cdb6&lang=css"

import exportComponent from "D:\\SVNwork\\01_工程区\\01_代码\\RPAPortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4873cdb6"]])

export default __exports__